import LocationTemplate from './location.html';

export default angular
  .module('main.devices.edit.tabs.location', [])

  .directive('editDeviceLocationTab', () => {
    return {
      restrict: 'E',
      template: LocationTemplate,
      scope: {},
      controller: ($scope,
                   $rootScope,
                   $q,
                   $filter,
                   utils,
                   PermissionsService,
                   ToastsService,
                   EditDeviceDataProvider) => {
        const $t = $filter('translate');
        const orderBy = $filter('orderBy');
        $scope.dataProvider = EditDeviceDataProvider.instance;

        $scope.timeFormatStr = $t('datetime.mdyHM12');
        $scope.canChangeDeviceLocation = false;

        angular.extend($scope, {
          canEditDeviceLocation: canEditDeviceLocation,
          goToLocation: goToLocation,
          getLocationOrgName: getLocationOrgName,
          generateAddress: generateAddress,
          withinChildOrganization: withinChildOrganization,
          searchLocation: searchLocation,
          selectLocation: selectLocation,
          copyToClipboard: $rootScope.copyToClipboard,
        });

        init();

        function init() {
          $scope.loading = true;
          $q.all([
            $scope.dataProvider.deviceLocationResource.init(),
            $scope.dataProvider.deviceLocationOrganizationResource.init(),
            $scope.dataProvider.availableOrganizationsResource.init(),
            $scope.dataProvider.childOrganizationsResource.init(),
            $scope.dataProvider.currentOrganizationResource.init(),

            $scope.dataProvider.deviceSupportMultipleLocationSpacesResource.init(),
            $scope.dataProvider.deviceModelSpacesResource.init(),
            $scope.dataProvider.deviceSpacesResource.init(),
            $scope.dataProvider.deviceInfoResource.init(),
          ])
            .then(() => initSpaces())
            .then(() => {
              $scope.loading = false;
              initViewModel();
            }, (err) => {
              // utils.handleApiError(err);
              $scope.loading = false;
            });
        }

        function initViewModel() {
          $scope.location = angular.copy($scope.dataProvider.deviceLocationResource.value);
          $scope.orgInfo = $scope.dataProvider.currentOrganizationResource.value;
          $scope.deviceInfo = $scope.dataProvider.deviceInfoResource.value;

          // Enable change location only for devices that do not have proxy
          if ($scope.deviceInfo && $scope.deviceInfo.device) {
            $scope.canChangeDeviceLocation = PermissionsService.canIEditDevice($scope.deviceInfo.device) && !$scope.deviceInfo.device.proxyId;
          }
        }

        function initSpaces() {
          $scope.locationSpacesMultiple = !!$scope.dataProvider.deviceSupportMultipleLocationSpacesResource.value;
          let deviceModelSpaces = angular.copy($scope.dataProvider.deviceModelSpacesResource.value);
          const deviceSpaces = angular.copy($scope.dataProvider.deviceSpacesResource.value);

          if (deviceModelSpaces?.length === 0) {
            $scope.locationSpaces = deviceSpaces.map((el, i) => {
              el.index = i;
              return el;
            });
            initLocationSpaces();
            return;
          }

          return $scope.dataProvider.locationSpacesResource.init()
            .then(locationSpaces => {
              deviceModelSpaces = deviceModelSpaces
                .filter(dms => !locationSpaces.some(ls => ls.name === dms.name && ls.type === dms.type));
              utils.mergeByProperty(deviceModelSpaces, locationSpaces, ['type', 'name', 'id']);
              deviceModelSpaces = orderBy(deviceModelSpaces, 'name');

              $scope.locationSpaces = deviceModelSpaces
                .map((el, i) => {
                  el.index = i;
                  return el;
                });

              $scope.selectedSpaces = deviceSpaces.map(el => el = deviceModelSpaces.findIndex(val => val.id === el.id));
              let index = deviceModelSpaces.findIndex(el => deviceSpaces[0] && el.id === deviceSpaces[0].id);
              $scope.selectedSpace = index === -1 ? null : index;
              initLocationSpaces();
            }, err => {
              $scope.locationSpaces = deviceModelSpaces;
              initLocationSpaces();
              utils.handleApiError(err);
            });
        }

        function initLocationSpaces() {
          if (!$scope.locationSpaces || $scope.locationSpaces.length === 0) {
            return;
          }

          // Start watching space(s) changes
          $scope.$watchGroup(['selectedSpaces', 'selectedSpace'], (newValue, oldValue) => {
            if ($scope.loading || $scope.locationSpacesMultiple === undefined) {
              return;
            }

            if ($scope.locationSpacesMultiple) {
              if (newValue[0].length !== oldValue[0].length) {
                updateDeviceSpaces(newValue[0], oldValue[0]);
              }
            } else {
              if (newValue[1] !== oldValue[1]) {
                updateDeviceSpaces(newValue[1], oldValue[1]);
              }
            }
          });
        }

        /**
         * Determine what space to link and what spaces to unlink.
         * @param {(number|null)|Array<{}>} newValue
         * @param {(number|null)|Array<{}>} oldValue
         */
        function updateDeviceSpaces(newValue, oldValue) {
          $scope.spacesUpdating = true;

          // Multiple spaces to unlink
          let unlinkElements = [];
          let linkIndex;

          if ($scope.locationSpacesMultiple) {
            newValue = newValue.map(val => parseInt(val));
            oldValue = oldValue.map(val => parseInt(val));
            let unlinkIds = oldValue.filter(el => newValue.indexOf(el) < 0);
            unlinkElements = $scope.locationSpaces.filter((e, i) => unlinkIds.indexOf(i) >= 0);
            linkIndex = newValue.find(el => oldValue.indexOf(el) < 0);
          } else {
            let unlinkElement = $scope.locationSpaces.find((e, i) => i === oldValue);
            unlinkElement && unlinkElements.push(unlinkElement);
            linkIndex = newValue;
          }

          return unlinkSpaces(unlinkElements)
            .then(() => addSpace($scope.locationSpaces[linkIndex], linkIndex));
        }

        /**
         * Link device space once at time.
         * @param {Object|null} space
         * @param {number} index
         */
        function addSpace(space, index) {
          // Close multiple dropdown
          if ($scope.locationSpacesMultiple) {
            $('#dropdown-spaces').dropdown('hide');
          }

          if (!space) {
            $scope.spacesUpdating = false;
            return $q.resolve();
          }

          if (space.id) {
            return linkSpace(space.id);
          } else {
            $scope.dataProvider.addLocationSpace(space.type, space.name)
              .then(data => {
                if (data?.spaceId) {
                  $scope.locationSpaces[index].id = data.spaceId;
                  return linkSpace(data.spaceId);
                } else {
                  ToastsService.error($t('locations.edit.spaces.errorMessageTitle'), $t('locations.edit.spaces.errorMessageDesc'));
                  $scope.spacesUpdating = false;
                }
              }, err => {
                utils.handleApiError(err);
                $scope.spacesUpdating = false;
              });
          }
        }

        /**
         * Link space
         * @param {string} spaceId
         * @return {Promise<void>}
         */
        function linkSpace(spaceId) {
          return $scope.dataProvider.linkSpace(spaceId)
            .then(() => {
              ToastsService.success();
              $scope.spacesUpdating = false;
            }, err => {
              utils.handleApiError(err);
              $scope.spacesUpdating = false;
            });
        }

        /**
         * Unlink multiple device spaces at once.
         * @param {Array<{}>} spaces
         * @returns {Promise}
         */
        function unlinkSpaces(spaces) {
          if (!spaces || spaces.length === 0) {
            return $q.resolve();
          }

          return $scope.dataProvider.unlinkSpaces(spaces);
        }

        function canEditDeviceLocation() {
          if ($scope.dataProvider.deviceLocationResource.loading || !$scope.dataProvider.deviceLocationResource.value) {
            return false;
          }
          return PermissionsService.canIEditLocation($scope.dataProvider.deviceLocationResource.value);
        }

        function goToLocation() {
          if ($scope.loading || !canEditDeviceLocation()) {
            return;
          }
          $scope.dataProvider.goToDeviceLocation();
        }

        function getLocationOrgName(location) {
          if (!location || !location.organizationId) {
            return $t('locations.list.notAtOrg');
          }

          let org = $scope.dataProvider.availableOrganizationsResource.value.find(element => {
            return location.organizationId === element.id;
          });
          if (org && org.name) {
            return $t('locations.list.atOrg', { name: org.name });
          } else {
            return $t('common.unknownOrganization');
          }
        }

        function generateAddress(location) {
          let address = utils.generateAddress(location);
          if (!address) {
            return $t('common.unknown-address');
          }
          return address;
        }

        /**
         * Test location if it's in related organization
         * @return {boolean}
         */
        function withinChildOrganization() {
          if ($scope.location) {
            return $scope.dataProvider.childOrganizationsResource.value?.some(org => org.id === $scope.location.organizationId);
          }
        }

        function searchLocation() {
          if ($scope.loading || $scope.searchingLocations) {
            return;
          }
          if (!$scope.searchLocationVal) {
            $scope.locations = [];
            return;
          }
          $scope.searchingLocations = true;
          $scope.completedSearchLocation = false;

          $scope.dataProvider.searchLocations($scope.searchLocationVal)
            .then((locations) => {
              $scope.completedSearchLocation = true;
              $scope.searchingLocations = false;
              $scope.locations = locations || [];
              $scope.locations = $scope.locations.filter(l => l.id !== $scope.location.id);
            }, (err) => {
              utils.handleApiError(err);
              $scope.searchingLocations = false;
              $scope.locations = [];
            });
        }

        function selectLocation(location) {
          if ($scope.loading || $scope.searchingLocations || !location) {
            return;
          }
          $scope.loading = true;
          return $scope.dataProvider.bindDeviceToLocation(location)
            .then(() => {
              $scope.loading = false;
              ToastsService.success(null, $t('common.move-device-success'));

              $scope.completedSearchLocation = false;
              $scope.searchingLocations = false;
              $scope.locations = [];

              $scope.dataProvider.goBack();
            }, (err) => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }
      }
    };
  })
  .name;
